module.exports = __webpack_public_path__ + "static/media/paypal-visa.a58e8a8d.jpg";